import { useState } from 'react';

const useCarousel = (options) => {
  const [selectedIndex, setSelectedIndex] = useState(0);

  const rotate = (direction = 1) => {
    let newIndex = selectedIndex + direction;
    if (newIndex < 0) newIndex = options.length + (newIndex % options.length);
    if (newIndex > options.length - 1) newIndex %= options.length;
    setSelectedIndex(newIndex);
  };

  return [
    options[selectedIndex],
    rotate,
    selectedIndex,
  ];
};

export default useCarousel;
